import dateFormat from "dateformat"
import moment from "moment"
import { numberFormatter } from "./numbers"
import { localDate } from "src/data/services/time-zone-service"

export function now() {
    return smrtLinkDateFormat(new Date())
}

export function nowTime() {
    return dateFormat(new Date(), "hh:MM:ss TT")
}

export function nowForFileNames() {
    return dateFormat(new Date(), "yyyy-mm-dd__MM-ss-TT")
}

export function smrtLinkDateFormat(d: Date, showSeconds: boolean = true, useUTC: boolean = false): string {
    if (String(d) !== "Invalid Date") {
        if (useUTC) {
            // Use moment.utc() to format in UTC - converts dateformat format string to moment format
            // dateformat: yyyy-mm-dd, hh:MM:ss TT
            // moment:     YYYY-MM-DD, hh:mm:ss A
            const momentFormat = `YYYY-MM-DD, hh:mm${showSeconds ? ":ss" : ""} A`
            return moment.utc(d).format(momentFormat)
        } else {
            const date = localDate(d)
            return dateFormat(date, `yyyy-mm-dd, hh:MM${showSeconds ? ":ss" : ""} TT`)
        }
    } else {
        return ""
    }
}

export function smrtLinkDateFormatDay(d: Date | string): string {
    if (String(d) !== "Invalid Date") {
        const asDate = typeof d === "string" ? new Date(d) : d
        const date = localDate(asDate)
        return dateFormat(date, "yyyy-mm-dd")
    } else {
        return ""
    }
}
export function smrtLinkDateFormatFromString(s: string) {
    const d = new Date(s)
    return smrtLinkDateFormat(d)
}


export function smrtLinkTimeFormat(d: Date): string {
    if (String(d) !== "Invalid Date") {
        return dateFormat(d, "hh:MM:ss TT")
    } else {
        return ""
    }
}

export const nowPlusSeconds = (seconds: number): Date => {
    const now = new Date()
    const nowMs = now.valueOf()
    return new Date(nowMs + 1000 * seconds)
}

export const minAndSec = (seconds: number) => {
    const min = Math.floor(seconds/60)
    const sec = seconds % 60
    let minSec = ""
    if (min) {
        minSec += `${min}min `
    }
    minSec += `${sec}s`
    return minSec
}
export const inHowManyDays = (date: Date): number => {
    const now = new Date()
    const msPerDay = 1000 * 60 * 60 * 24
    const diffInMs = date.getTime() - now.getTime()
    return Math.floor(diffInMs / msPerDay)
}
export const hours = ( seconds: number, precision: number) => {
    const h = seconds / (60*60)
    return `${numberFormatter(h, precision)}h`
}

export const durationString = (sec: number): string => {

    const secsPerDay = 60 * 60 * 24
    const days =  Math.floor(sec / secsPerDay)
    const daysClause = days > 0 ?
        (days >= 2 ? `${days} days` : `${days} day`) : ""

    let minutes = Math.ceil(sec / 60)
    let hours = (minutes / 60) % 24
    let hoursClause = ""
    if (days >= 1) {
        hours = Math.round(hours)
        hoursClause = hours === 1 ? `${hours}h` : `${hours}h`
        return `${daysClause} and ${hoursClause}`
    } else {
        if ( hours < 1) {
            return `${minutes}m`
        } else {
            hours = Math.floor(hours)
            minutes = minutes % 60
            return `${hours}h ${minutes}m`
        }
    }
}

export const timeUntil = (date: Date): string => {
    return durationString((new Date(date).getTime() - new Date().getTime()) / 1000)
}

export const durationStringCompact = (sec: number): string => {
    const secsPerDay = 60 * 60 * 24
    const days = Math.floor(sec / secsPerDay)
    const hours = Math.floor((sec % secsPerDay) / (60 * 60))
    
    if (days > 0) {
        if (hours > 0) {
            return `${days}d and ${hours}h`
        }
        return `${days}d`
    } else if (hours > 0) {
        return `${hours}h`
    } else {
        const minutes = Math.floor(sec / 60)
        return `${minutes}m`
    }
}

export const timeUntilCompact = (date: Date): string => {
    const seconds = (new Date(date).getTime() - new Date().getTime()) / 1000
    return durationStringCompact(seconds)
}